import { useSyncExternalStore } from "react";

/** Phone-sized viewports. Mirrors `media.mobile` in `tokens.stylex.ts`. */
export const MOBILE_QUERY = "(max-width: 767px)";

/** Live result of a CSS media query; re-renders when it flips. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/**
 * True on phone-sized viewports, where the app swaps to its mobile chrome
 * (tab bar, bottom sheets). Prefer `media.mobile` styles for anything CSS can
 * express; reach for this only when the component tree itself must change.
 */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}
